export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5058.298077a9.jpg";